import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { STEPS } from "./../util/constants";

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails'

// MUI Icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Custom
import SummaryContent from "./SummaryContent";

// Spacing
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 3, xl: 4 }

function Summary(props) {

    // Props
    const { t } = useTranslation()
    const step = useSelector(state => state.step)

    const theme = useTheme();
    // Styles
    const styles = {
        greenCheckIcon: {
            fill: theme.palette.success.main,
        },
        accordionRoot: {
            width: '100%'
        },
    }

    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingSummary = useMemo(() => {

        // Spacing
        const spacings = { xs: 0, sm: 1, md: 1, lg: 1, xl: 2 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // On mount
    useEffect(() => {

        return () => {
            // Clean up
        }
    }, [])
    const [expanded, setExpanded] = useState(step === STEPS.step4 || step === STEPS.step5);
    return (
        <>
            {
                smDown &&
                <Accordion
                    expanded={expanded}
                    onChange={(event, expanded) => {
                        setExpanded(expanded)
                    }}
                    square
                    sx={styles.accordionRoot}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography variant='h6' color='textPrimary'>{t('summaryTitle')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SummaryContent />
                    </AccordionDetails>
                </Accordion>
            }
            {!smDown &&
                <Box width={1} p={spacingRoot} boxShadow={1} bgcolor="background.paper" position='relative'><SummaryContent /></Box>
            }
        </>
    )
}

// Connect redux and translation
export default Summary